export class RoleAuth {
    public create = false;
    public update = false;
    public delete = false;
    public read = false;
    constructor(d: Array<string> = []) {
        d.forEach((e, i) => {
            switch (e) {
                case 'create':
                    this.create = true;
                    break;
                case 'update':
                    this.update = true;
                    break;
                case 'delete':
                    this.delete = true;
                    break;
                case 'read':
                    this.read = true;
                    break;
                default:
                    break;
            }
        })
    }
}
